import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryTabs({ activeSlug }: { activeSlug?: string }) {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-1 h-5 rounded-full bg-primary-500"></span>
          <h2 className="text-base font-semibold text-foreground-900">影视分类</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-800 border border-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}